export const DropDown = ['True', 'False', 'All'];

export const GenderList = [
  { id: 0, label: 'All' },
  { id: 1, label: 'Male' },
  { id: 2, label: 'Female' },
];
